import { render, staticRenderFns } from "./FlowerItem.vue?vue&type=template&id=031bb438&"
import script from "./FlowerItem.vue?vue&type=script&lang=js&"
export * from "./FlowerItem.vue?vue&type=script&lang=js&"
import style0 from "./FlowerItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports